import actionTypes from './actionTypes';

export const getAllMedia = (payload) => ({
    type: actionTypes.GET_ALL_MEDIA,
    payload
});

export const addNewMedia = (payload) => ({
    type: actionTypes.ADD_NEW_MEDIA,
    payload
});
